import { render } from "./SmartPressInit.vue?vue&type=template&id=5e492006"
import script from "./SmartPressInit.vue?vue&type=script&lang=js"
export * from "./SmartPressInit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__